/* eslint-disable max-lines-per-function */
'use strict';

angular.module('webAgro1App').factory('RecomendacoesSemeaduraObjectService',
// eslint-disable-next-line
function($filter, $rootScope, UnidadesService) {
    return {
      convertToGlebasAttributes: function(recomendacao) {
        const glebas = [];
        for (let i = 0; i < recomendacao.glebas.length; i++) {
          const gleba = recomendacao.glebas[i];
          glebas.push({
            insumo_id: gleba.cultivar.item_id,
            insumo_tipo: gleba.cultivar.tipo_item,
            gleba_id: gleba.gleba.id,
            area: gleba.area_aplicada,
            data_inicio: $filter('date')(gleba.data_inicio, 'yyyy-MM-dd'),
            data_fim: $filter('date')(gleba.data_fim_max, 'yyyy-MM-dd'),
            dose: gleba.quantidade.resultado,
            parametros: {
              pms: gleba.pms,
              pg: gleba.pg,
              ts: gleba.ts,
              densidade: gleba.densidade,
              ciclo_dias: gleba.ciclo,
              tempo_dias: gleba.duracao,
              numero_sementes_para_regulagem: gleba.regulagem.resultado,
              data_estimada_colheita: $filter('date')(gleba.colheita, 'yyyy-MM-dd'),
              densidade_corrigida: gleba.densidade_corrigida,
              data_fim_min: $filter('date')(gleba.data_fim_min, 'yyyy-MM-dd'),
              dose: gleba.dose
            }
          });
        }
        return glebas;
      },

      convertToAdubosAttributes: function(recomendacao) {
        const adubos = [];
        for (let i = 0; i < recomendacao.adubacao.length; i++) {
          const adubo = recomendacao.adubacao[i];
          adubos.push({
            area: +adubo.area || (+((recomendacao.glebas.filter(function(gleba) {
              return gleba.gleba.id === adubo.gleba.id;
            })[0] || {}).gleba || {}).area_total),
            insumo_id: adubo.adubo.item_id,
            insumo_tipo: adubo.adubo.tipo_item,
            gleba_id: adubo.gleba.id,
            dose: adubo.dose,
            parametros: {
              total: adubo.total,
              regulagem: adubo.regulagem_adubacao.resultado,
              regulagem_minima: adubo.regulagem_adubacao.minima,
              regulagem_maxima: adubo.regulagem_adubacao.maxima
            }
          });
        }
        return adubos;
      },

      convertToTratamentosAttributes: function(recomendacao) {
        let tratamentos = [];
        recomendacao.tratamentos.forEach(function(tratamento) {
          const insumos = tratamento.insumos.map(function(insumo) {
            const cultivarDestinoTipo = tratamento.cultivarDestino.item_tipo || tratamento.cultivarDestino.tipo_item;

            return {
              insumo_id: insumo.id,
              insumo_tipo: insumo.tipo,
              semente_para_tratar_id: tratamento.cultivar.item_id,
              semente_para_tratar_tipo: tratamento.cultivar.item_tipo,
              sem_para_tratar_destino_id: tratamento.cultivarDestino.item_id,
              sem_para_tratar_destino_tipo: cultivarDestinoTipo,
              data_inicio: $filter('date')(tratamento.cultivar.data_inicio, 'yyyy-MM-dd'),
              data_fim: $filter('date')(tratamento.cultivar.data_fim, 'yyyy-MM-dd'),
              dose: insumo.dose,
              quantidade_total_sementes: tratamento.totalKg
            };
          });
          tratamentos = tratamentos.concat(insumos);
        });

        return tratamentos;
      },

      convertToSend: function(recomendacao) {
        const result = {
          id: recomendacao.id,
          status: recomendacao.status,
          situacao: recomendacao.situacao,
          safra_id: recomendacao.safra.id,
          periodo_id: (recomendacao.periodo || {}).codigo,
          atividade_id: recomendacao.cultura.id,
          propriedade_id: recomendacao.propriedade.id,
          parametros: {
            rendimento_operacional_minimo: recomendacao.rendimento_minimo,
            rendimento_operacional_maximo: recomendacao.rendimento_maximo,
            espacamento: recomendacao.espacamento,
            correcao_densidade: recomendacao.densidade,
            correcao_quantidade: recomendacao.quantidade,
            distribuicao_regulagem: recomendacao.regulagem,
            distribuicao_regulagem_abubos: recomendacao.regulagem_adubacao,
            calculo_margem_seguranca: recomendacao.calculo_margem_seguranca,
            cobertura: recomendacao.cobertura,
            area_remontes: recomendacao.area_remontes,
            observacao: recomendacao.observacao
          },
          cultivares_attributes: [],
          adubos_attributes: []
        };

        result.cultivares_attributes = this.convertToGlebasAttributes(recomendacao);

        result.adubos_attributes = this.convertToAdubosAttributes(recomendacao);

        result.tratamentos_attributes = this.convertToTratamentosAttributes(recomendacao);

        return result;
      },

      convertToObject: function(recomendacao, cultivares, adubos) {
        const temRecomendacao = recomendacao && recomendacao.id;
        const parametros = (recomendacao || {}).parametros || {};

        const result = !temRecomendacao ? {} : {
          id: recomendacao.id,
          situacao: recomendacao.situacao,
          status: recomendacao.status,
          propriedade: recomendacao.propriedade,
          safra: $rootScope.safras.find(function(safra) {
            return safra.id === recomendacao.safra_id;
          }) || recomendacao.safra_id,
          cultura: recomendacao.atividade,
          periodo: recomendacao.periodo,
          rendimento_minimo: parametros.rendimento_operacional_minimo,
          rendimento_maximo: parametros.rendimento_operacional_maximo,
          espacamento: parametros.espacamento,
          densidade: parametros.correcao_densidade,
          quantidade: parametros.correcao_quantidade,
          regulagem: parametros.distribuicao_regulagem,
          regulagem_adubacao: parametros.distribuicao_regulagem_abubos,
          area_remontes: parametros.area_remontes,
          observacao: parametros.observacao,
          glebas: this.getCultivares(recomendacao, cultivares),
          adubacao: this.getAdubos(recomendacao, adubos),
          usuario: recomendacao.usuario,
          calculo_margem_seguranca: parametros.calculo_margem_seguranca,
          tratamentos: this.getTratamentos(recomendacao),
          cobertura: parametros.cobertura,
          data_inicio: recomendacao.data_inicio
        };

        return result;
      },

      getCultivares: function(recomendacao, cultivares) {
        if (!recomendacao.cultivares) {
          return recomendacao.glebas;
        }

        return recomendacao.cultivares.map(function(c) {
          return {
            gleba: recomendacao.glebas.filter(function(gleba) {
              return gleba.id === c.gleba_id;
            })[0],
            area_aplicada: c.area,
            data_inicio: c.data_inicio,
            data_fim_min: c.parametros.data_fim_min,
            data_fim_max: c.data_fim,
            dose: c.dose,
            cultivar: cultivares.filter(function(cultivar) {
              return cultivar.item_id === c.insumo_id && cultivar.tipo_item === c.insumo_tipo;
            })[0],
            ts: c.parametros.ts,
            densidade: c.parametros.densidade,
            pms: c.parametros.pms,
            pg: c.parametros.pg,
            ciclo: c.parametros.ciclo_dias,
            duracao: c.parametros.tempo_dias,
            colheita: c.parametros.data_estimada_colheita
          };
        });
      },

      getAdubos: function(recomendacao, adubos) {
        if (recomendacao.adubos) {
          return recomendacao.adubos.map(function(a) {
            return {
              gleba: recomendacao.glebas.filter(function(gleba) {
                return gleba.id === a.gleba_id;
              })[0],
              adubo: adubos.filter(function(adubo) {
                return adubo.item_id === a.insumo_id && adubo.tipo_item === a.insumo_tipo;
              })[0],
              dose: a.dose,
              area: a.area
            };
          });
        }

        return [];
      },

      getTratamentos: function(recomendacao) {
        let tratamentos = [];
        const _this = this;
        if (recomendacao.tratamentos) {
          tratamentos = recomendacao.tratamentos.reduce(function(group, tratamento) {
            const found = group.filter(function(grouped) {
              return grouped.cultivar.item_id === tratamento.semente_para_tratar.item_id &&
              grouped.totalKg === +tratamento.quantidade_total_sementes;
            })[0];
            if (!found) {
              group.push(_this.getTratamento(tratamento));
            } else {
              found.insumos.push(_this.getInsumoTratamento(tratamento));
            }

            return group;
          }, []);
        }
        return tratamentos;
      },

      getTratamento: function(tratamento) {
        return {
          cultivar: this.getCultivarTratamento(tratamento),
          cultivarDestino: this.getCultivarTratamentoDestino(tratamento),
          totalKg: +tratamento.quantidade_total_sementes,
          insumos: [this.getInsumoTratamento(tratamento)]
        };
      },

      getCultivarTratamento: function(tratamento) {
        return {
          data_inicio: tratamento.data_inicio,
          data_fim: tratamento.data_fim,
          descricao: tratamento.semente_para_tratar.descricao,
          item_id: tratamento.semente_para_tratar.item_id,
          item_tipo: tratamento.semente_para_tratar.tipo_item
        };
      },

      getCultivarTratamentoDestino: function(tratamento) {
        return {
          data_inicio: tratamento.data_inicio,
          data_fim: tratamento.data_fim,
          descricao: (tratamento.semente_para_tratar_destino || {}).descricao,
          item_id: (tratamento.semente_para_tratar_destino || {}).item_id,
          item_tipo: (tratamento.semente_para_tratar_destino || {}).tipo_item
        };
      },

      getInsumoTratamento: function(tratamento) {
        return {
          controla_lote: tratamento.item_estoque.controla_lote,
          descricao: tratamento.item_estoque.descricao,
          dose: +tratamento.dose,
          id: tratamento.item_estoque.item_id,
          tipo: tratamento.item_estoque.tipo_item,
          unidade: tratamento.item_estoque.unidade,
          unidadeSelected: UnidadesService
            .getMeasureUnitysFromDescription(tratamento.item_estoque.unidade.descricao)
        };
      }
    };
  });
